export default __webpack_public_path__ + "static/media/bw.42436499.svg";